import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";

const CategoryForm = ({
  token,
  onCloseModal,
  isEdit,
  rowData,
  selectedIssueType,
  refetchData,
}) => {
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Category name is required")
      .min(2, "Category name must be at least 2 characters")
      .max(100, "Category name must be less than 100 characters"),
  });

  const formik = useFormik({
    initialValues: {
      name: isEdit ? rowData?.name || "" : "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (isEdit) {
          const payload = {
            uid: rowData?.uid,
            issue_type_id: selectedIssueType?.uid || rowData?.issue_type_id,
            name: values.name,
          };

          const result = await dispatch(
            commonPostPutApi({
              method: "PUT",
              endpoint: "/ticketSystem/category/update",
              token: token,
              payload: payload,
            })
          );

          if (result?.payload?.status) {
            toast.success(
              result?.payload?.message || "Category updated successfully!"
            );
            refetchData();
            onCloseModal();
          } else {
            toast.error(
              result?.payload?.message || "Failed to update category"
            );
          }
        } else {
          if (!selectedIssueType?.uid) {
            toast.error("Please select an issue type first");
            return;
          }

          const payload = {
            issue_type_id: selectedIssueType.uid,
            name: values.name,
          };

          const result = await dispatch(
            commonPostPutApi({
              method: "POST",
              endpoint: "/ticketSystem/category/add",
              token: token,
              payload: payload,
            })
          );

          if (result?.payload?.status) {
            toast.success(
              result?.payload?.message || "Category added successfully!"
            );
            refetchData();
            onCloseModal();
          } else {
            toast.error(result?.payload?.message || "Failed to add category");
          }
        }
      } catch (error) {
        toast.error("An error occurred. Please try again.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Edit" : "Add"} Category`}
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        btnTxt={isEdit ? "Update" : "Add"}
        onClose={onCloseModal}
      />

      <form className="formContainer" onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid twoGridSystem">
          {selectedIssueType && (
            <div className="formInputBox">
              <label className="formInputLabel">Issue Type</label>
              <div className="commonWrapper">
                <div className="selected-item-display">
                  {selectedIssueType.name}
                </div>
              </div>
            </div>
          )}

          <div className="formInputBox">
            <label htmlFor="name" className="formInputLabel">
              Category Name <span className="required">*</span>
            </label>
            <div className="commonWrapper">
              <input
                type="text"
                id="name"
                name="name"
                className="formInput"
                placeholder="Enter category name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.name && formik.errors.name && (
              <div className="error-message">{formik.errors.name}</div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default CategoryForm;
